<template>
  <div
    class="money-pay"
    v-loading="loading"
    element-loading-text="优惠计算中..."
  >
    <div v-if="showDiscounts && inputPrice > 0">
      <el-card class="box-card activityList">
        <div class="activity-cont" v-if="newData.recharge_dec_money != 0">
          <span>
            <el-checkbox :value="true" :disabled="true">充值优惠</el-checkbox>
          </span>
          <span style="color:#f56c6c">
            -{{ newData.recharge_dec_money }}元
          </span>
        </div>
        <mutexComponent
          v-if="duoxuan"
          ref="mutexComponent"
          :sendStatus="true"
          :optionMutex="optionMutex"
          @openConponList="openConponList"
          @changeOption="changeOption"
          :useNum="useNum"
          :bottom_ticket="bottom_ticket"
          :integralNum="integralNum_s"
          :dedIntegral="dedIntegral"
          :dedIntegralMoney="dedIntegralMoney"
          :new-data="newData"
          :mutexData="mutexData"
        ></mutexComponent>
        <div v-if="mutexData.length > 0">
          <div style="margin: 10px 0;color: red">以下优惠不同享</div>
          <mutexComponent
            v-if="danxuan"
            ref="mutexComponent"
            :sendStatus="false"
            :mutexData="mutexData"
            :optionMutex="optionMutex"
            @openConponList="openConponList"
            @changeOption="changeOption"
            :useNum="useNum"
            :bottom_ticket="bottom_ticket"
            :integralNum="integralNum_s"
            :dedIntegral="dedIntegral"
            :dedIntegralMoney="dedIntegralMoney"
            :new-data="newData"
          ></mutexComponent>
        </div>
        <div
          class="No_preferential"
          style="height: auto"
          v-if="!danxuan && !duoxuan"
        >
          <img src="../../../../../../public/img/pay/zanwuyouhui.png" alt />
          <p>暂无优惠</p>
        </div>
        <!-- 是否打印发票 -->
        <div style="margin-top: 20px" v-if="isInvoice">
          <el-checkbox v-model="Select_invoice">
            是否打印发票
          </el-checkbox>
          <el-popover
            placement="top-start"
            title="是否打印发票"
            width="200"
            trigger="hover"
            content="想要更改设置，请前去设置功能开关"
          >
            <el-button
              slot="reference"
              type="text"
              style="margin-left: 10px;"
              icon="el-icon-warning-outline"
            >
              帮助
            </el-button>
          </el-popover>
          <div v-if="Select_invoice">
            <el-radio v-model="radio" label="1" @change="Radioinvoice"
              >个人发票</el-radio
            >
            <el-radio v-model="radio" label="2" @change="Radioinvoice"
              >企业发票</el-radio
            >
          </div>
        </div>
      </el-card>
    </div>
    <div class="No_preferential" v-else>
      <img src="../../../../../../public/img/pay/zanwuyouhui.png" alt />
      <p>暂无优惠</p>
    </div>
    <div style="margin-bottom: 4px">
      <el-card class="box-card pay_infor">
        <div class="pay_price">
          <span>还需支付:</span>
          <div class="price">
            ￥
            <span v-if="newData.amount"
              >{{ newData.amount
              }}<span
                style="font-size: 12px;color: #cccccc"
                v-if="newData.zero_fee > 0"
                >(加油包:{{ newData.zero_fee }})</span
              ></span
            >
            <span v-else>0</span>
          </div>
        </div>
      </el-card>
      <el-card class="box-card pay_infor">
        <div class="selectPay_type">
          <div
            class="shell"
            v-for="(item, index) in newPay_type"
            :key="index"
            @click="chosePayType(index, item)"
            :class="payIndex == index ? '  shell pay_type_Active' : 'shell'"
          >
            <div class="pay_type">
              <img :src="item.imgUrl" alt v-if="item.imgStatus" />
              <span>{{ item.account_name }}</span>
              <span v-if="!item.imgStatus">{{ item.balance }}</span>
            </div>
          </div>
        </div>
      </el-card>
      <!--      <el-card class="box-card pay_infor">-->
      <!--        <el-input placeholder="备注" v-model="remarkInput" clearable></el-input>-->
      <!--      </el-card>-->
      <el-card class="box-card pay_infor submitAccounts" style="margin:0">
        <el-button
          type="success"
          plain
          @click="passwordldPop"
          :disabled="!(showDiscounts && inputPrice > 0)"
        >
          <img src="../../../../../../public/img/pay/jiezhang.png" alt />
          <span>结账</span>
        </el-button>
        <paySuccess ref="pay_Success" @payEnd="payEnd"></paySuccess>
      </el-card>
    </div>
    <el-drawer
      custom-class="select_coupon-drawer"
      title="选取优惠券"
      :modal="false"
      :visible.sync="drawer"
      :withHeader="false"
    >
      <div class="select_coupon">
        <el-tabs v-model="activeName">
          <el-tab-pane label="满减券" name="1"></el-tab-pane>
          <el-tab-pane label="折扣券" name="2"></el-tab-pane>
          <el-tab-pane label="代金券" name="3"></el-tab-pane>
        </el-tabs>
        <div class="coupon_list">
          <el-radio-group v-model="couponradio" size="small" @change="">
            <div
              class="coupon-item"
              v-for="(item, index) in conponList[activeName]"
              :key="index"
            >
              <div class="style-three">
                <div class="info-box">
                  <div class="coupon-money">
                    <div class="lay of" v-if="activeName == 2">
                      <span>优惠{{ item.dec_money }}元</span>
                    </div>
                    <div class="lay of" v-else>
                      ￥
                      <em v-if="activeName == 1">
                        {{ Number(item.dec_money * item.check_num).toFixed(2) }}
                      </em>
                      <em v-else>{{ item.dec_money }}</em>
                    </div>
                    <div class="lay">
                      <p class="tit">{{ item.title }}</p>
                      <p class="demand">该券最多可用{{ item.max_use }}张</p>
                      <div @click="nowconponIdx = index">
                        <el-input-number
                          v-if="activeName != 2"
                          v-model="item.check_num"
                          size="mini"
                          :min="1"
                          :max="item.max_use"
                          label="描述文字"
                          @change="select_Cou(item)"
                        ></el-input-number>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="get-btn">
                  <el-radio
                    :label="item.IsShow"
                    @change="select_Cou(item)"
                    border
                    style="margin-left:15px"
                    >选择</el-radio
                  >
                </div>
              </div>
            </div>
          </el-radio-group>
        </div>
      </div>
      <div class="noUseconpon">
        <el-button type="primary" plain @click="noCounpon"
          >不使用优惠</el-button
        >
      </div>
    </el-drawer>
    <!-- ，密码确认弹窗 -->
    <el-dialog
      :visible.sync="passwordPopStatus"
      title="密码确认"
      width="400px"
      :before-close="handlePassworld"
    >
      <el-form ref="form" :model="passwordForm" label-width="100px">
        <div v-if="!forgetStatus">
          <el-form-item label="请输入密码">
            <el-input
              v-model="passwordForm.confirmPassword"
              @input="changeIc"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button
              type="text"
              @click="
                forgetStatus = true;
                passwordForm.mobile = user_infor.mobile;
              "
            >
              忘记密码？
            </el-button>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="用户手机号">
            <el-input v-model="passwordForm.mobile" disabled></el-input>
          </el-form-item>
          <el-form-item label="校验码">
            <el-input placeholder="请输入内容" v-model="imgCode">
              <template slot="append">
                <img :src="imageBase64" alt="" style="width: 100px;height: 20px;" @click="getImageData"/>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="验证码">
            <el-input class="input_box" v-model="passwordForm.code">
              <template slot="append">
                <el-link
                  :disabled="btn_status"
                  @click="getCode(1)"
                  type="primary"
                  >{{ code_text }}</el-link
                >
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="设置密码">
            <el-input
              show-password
              v-model="passwordForm.pay_pass"
              placeholder="请输入六位数字密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码">
            <el-input
              show-password
              v-model="passwordForm.re_pay_pass"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button type="text" @click="forgetStatus = false">
              我记得密码
            </el-button>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="forgetStatus">
        <el-button type="primary" @click="resetPassworld(1)">
          重置密码</el-button
        >
      </span>
    </el-dialog>
    <!-- 设置密码弹窗 -->
    <el-dialog
      :visible.sync="setpasswordPopStatus"
      title="用户暂未设置密码"
      width="400px"
      :before-close="handlePassworld"
    >
      <el-form ref="form" :model="passwordForm" label-width="100px">
        <el-form-item label="用户手机号">
          <el-input v-model="passwordForm.mobile" disabled></el-input>
        </el-form-item>
 <el-form-item label="校验码">
            <el-input placeholder="请输入内容" v-model="imgCode">
              <template slot="append">
                <img :src="imageBase64" alt="" style="width: 100px;height: 20px;" @click="getImageData"/>
              </template>
            </el-input>
          </el-form-item>
        <el-form-item label="验证码">
          <el-input class="input_box" v-model="passwordForm.code">
            <template slot="append">
              <el-link
                :disabled="btn_status"
                @click="getCode(1)"
                type="primary"
                >{{ code_text }}</el-link
              >
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input
            show-password
            v-model="passwordForm.pay_pass"
            placeholder="请输入六位数字密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input show-password v-model="passwordForm.re_pay_pass"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="resetPassworld(2)"
          >设置密码</el-button
        >
      </span>
    </el-dialog>
    <!-- 微信支付宝 -->
    <!-- 微信支付宝 -->
    <el-dialog
      :title="
        this.newPay_type.length > 0
          ? this.newPay_type[this.payIndex].account_name + ':扫码支付'
          : ''
      "
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
    >
      <div class="qrcode-con" id="qrcode"></div>
    </el-dialog>
    <!-- pos银行刷卡 -->
    <el-dialog
      title="等待用户刷卡"
      :visible.sync="dialogVisiblePos"
      width="400px"
      :before-close="handleClosePos"
    >
      <!-- <div>请用户出示银行卡进行刷卡支付！！！</div> -->
      <img src="@public/img/wait.gif" alt="" style="width: 100%" />
    </el-dialog>
    <el-dialog
      title="等待用户出示付款码"
      :visible.sync="dialogVisibleScancode"
      width="400px"
      style="padding: 0;overflow: hidden"
      :before-close="handleClosePos"
      destroy-on-close
    >
      <div v-loading="loading" element-loading-text="支付中...">
        <img
          src="@public/img/saoma.gif"
          alt=""
          style="width: 360px;height: 340px"
        />
        <el-input
          style="opacity:0;width:10px;height: 2px"
          ref="inputbox_pay"
          @change="keyup_submit"
          size="mini"
          v-model="pay_code"
          @blur="Blur"
        ></el-input>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  CreateOrder_new,
  judgePayPass,
  oderYH,
  offline_order_query,
  saveReceipt,
} from "@/api/vip";
import QRCode from "qrcodejs2";
import { iCSendSms, searchOrder, setPayPass, verifyPayPass } from "@/api/ic";
import { getConfigButton } from "@/api/set";
import paySuccess from "./paySuccess";
import verificationCode from "@/utils/verificationCode";
import mutexComponent from "./mutexComponent";
import {
  balanceData,
  checkPayQrcodeStatus,
  createPayQrcode,
  psw_config,
} from "@/api/pay";

import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  components: {
    paySuccess,
    mutexComponent,
  },
  props: [
    "inputPrice",
    "integralNum",
    "user_infor",
    "oil_infor",
    "parentOptionId",
  ],

  data() {
    return {
      imageBase64:"",
      saomaForm: {},
      pay_code: "",
      dialogVisibleScancode: false,
      radio: "",
      loading: false,
      Loading_Text: "优惠计算中...",
      Select_invoice: false,
      coupon_type: 0,
      integralNum_s: 0,
      setpasswordPopStatus: false,
      dialogVisible: false,
      dialogVisiblePos: false,
      payPrice: 0, // 最终支付金额
      conponList: [], // 优惠券列表
      useNum: 0, // 当前选中优惠券的数量
      bottom_ticket: `选择优惠券`, //优惠券提示
      nowconponIdx: "", // 优惠券idx
      dedIntegral: 0, // 使用的抵扣积分
      dedIntegralMoney: 0, // 抵扣积分减免的钱
      activeName: "1",
      couponradio: "",
      showDiscounts: false,
      drawer: false,
      payIndex: 0, // 支付方式选项
      newData: {},
      imgCode:"",
      uuid:"",
      basePay: [
        {
          account_name: "现金支付",
          payment_code: "cash",
          imgUrl: require("../../../../../../public/img/pay/xianjin.png"),
          imgStatus: true, //true  显示图片 false显示文本
        },
        {
          account_name: "微信支付",
          payment_code: "wxpay",
          imgUrl: require("../../../../../../public/img/pay/weixin.png"),
          imgStatus: true, //true  显示图片 false显示文本
        },
        {
          account_name: "支付宝支付",
          payment_code: "unionpay",
          imgUrl: require("../../../../../../public/img/pay/zhifu.png"),
          imgStatus: true, //true  显示图片 false显示文本
        },
        {
          account_name: "刷卡",
          payment_code: "pos",
          imgUrl: require("../../../../../../public/img/pay/yinhangka.png"),
          imgStatus: true, //true  显示图片 false显示文本
        },
      ],
      passwordPopStatus: false,
      forgetStatus: false,
      passwordForm: {
        confirmPassword: "",
        mobile: "",
        code: "",
        pay_pass: "",
        re_pay_pass: "",
      },
      code_text: "获取验证码",
      btn_status: false,
      timer: null,
      setStatus: false, //凑整设置
      mutexData: [], //后台设置项
      optionMutex: [], //互斥选项(前端选的)
      isInvoice: false,
      BalancePaySet: {
        user_level: 1,
        coupon_status: 1,
        points_status: 1,
      }, //余额优惠项
      newPay_type: [],
      postData: {
        cate_id: 0,
        point: 1,
        coupon: 1,
        discount: 1,
        platform: 0,
        platform_card_data_id: 0,
      },
      discount: {},
      platform: {},
      platform_dec: "",
      discount_dec: "",
      Yhq: false,
      jf: false,
      HY: false,
      PTK: false,
      Isdiscount: false,
      Isplatform: false,
      Iscoupon: false,
      Ispoint: false,
      duoxuan: false,
      danxuan: false,
      Invoice_id: "",
      open_manage_user_paypass: "1",
    };
  },
  watch: {
    //发票情况
    Select_invoice(val) {
      if (!val) {
        this.Invoice_id = "";
      }
    },
    //油品变更的情况
    oil_infor(val) {
      this.payIndex = 0;
      console.log("油品选择112", val);
      this.postData.cate_id = val.id;
      this.goPayMoney();
    },
    //会员信息变更情况
    user_infor(val) {
      this.payIndex = 0;
      console.log("油品选择11", val);
      this.goPayMoney();
    },
  },
  mounted() {
    console.log("panduan ", "0.00" > 0);
    this.configuration();
    this.getBalancePaySet();
    this.goPayMoney();
    this.getPswConfig();
  },
  methods: {
    async getImageData(){
      const data = await verificationCode.getImage();
      if(data){
        console.log("验证图片", data);
      this.imageBase64 = data.img;
      this.uuid = data.uuid;
      this.imgCode = ""
    }
  },
    Blur() {
      this.$refs.inputbox_pay.focus();
    },
    async getPswConfig() {
      const res = await psw_config({
        app_id: this.app_id,
        button_name: "open_manage_user_paypass",
      });
      if (res.code == 200) {
        this.open_manage_user_paypass = res.data.status;
      }
      console.log(res);
    },
    async Radioinvoice(val) {
      console.log("个人/企业", val);
      let data = {
        app_id: this.app_id,
        type: val,
        tax_name: "",
        tax_id: 0,
        bank: "",
        bank_account: "",
        mobile: "",
        address: "",
        is_default: 0,
      };
      const res = await saveReceipt(data);
      if (res.code == 200) {
        this.Invoice_id = res.data.id;
      } else {
        this.$message(res.msg);
      }
    },
    // 余额支付设置
    getBalancePaySet() {
      // this.page++;
      let data = {
        token: this.token,
        app_id: this.app_id,
      };
      balanceData(data).then((res) => {
        console.log("unionData222: ", res);
        if (res.code == 200) {
          this.BalancePaySet = JSON.parse(res.data.type);
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          document.getElementById("qrcode").innerHTML = "";
          setTimeout(() => {
            location.reload();
          }, 100);
        })
        .catch((_) => {});
    },
    handleClosePos(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          setTimeout(() => {
            location.reload();
          }, 500);
        })
        .catch((_) => {});
    },
    // 不使用优惠
    noCounpon() {
      this.drawer = false;
      this.postData.coupon_ids = "";
      this.postData.coupon = 0;
      let data = {
        ...this.postData,
        app_id: this.app_id,
        uid: this.user_infor.uid ? this.user_infor.uid : "",
        emp_id: localStorage.getItem("choseStaffId")
          ? localStorage.getItem("choseStaffId")
          : 0,
        money: this.inputPrice,
      };
      this.getAllType(data);
    },
    //多选
    changeOption(val) {
      console.log("优惠", val);
      let oldData = val;
      this.optionMutex = [];
      let metexShell = []; //互斥的选项
      oldData.forEach((item) => {
        if (!this.mutexData.includes(item)) {
          this.optionMutex.push(item);
        } else {
          metexShell.push(item);
        }
      });
      if (metexShell.length > 0) {
        // this.$message.warning("优惠互斥，优惠不同享！！");
        this.optionMutex.push(metexShell[metexShell.length - 1]);
      }
      this.minimumAnew();
    },
    // 优惠项数据重新加载
    minimumAnew() {
      console.log("huiqu", this.optionMutex);
      this.postData.discount = this.optionMutex.indexOf("3") == -1 ? 0 : 1;
      this.postData.coupon = this.optionMutex.indexOf("2") == -1 ? 0 : 1;
      this.postData.point = this.optionMutex.indexOf("1") == -1 ? 0 : 1;
      this.postData.platform = this.optionMutex.indexOf("4") == -1 ? 0 : 1;
      this.postData.cate_id = this.oil_infor.id;
      console.log("data", this.optionMutex.indexOf("1"), this.postData);
      let data = {
        ...this.postData,
        app_id: this.app_id,
        uid: this.user_infor.uid ? this.user_infor.uid : "",
        emp_id: localStorage.getItem("choseStaffId")
          ? localStorage.getItem("choseStaffId")
          : 0,
        money: this.inputPrice,
      };
      console.log("post", data);
      this.getAllType(data);
    },
    chosePayType(index, item) {
      this.payIndex = index;
      if (!this.user_infor) {
        return this.$message.warning("请选择会员!!");
      }
      if (!localStorage.getItem("choseStaffId")) {
        return this.$message.warning("请选择员工!!");
      }
      if (this.inputPrice <= 0 || this.inputPrice == "") {
        return this.$message.warning("请确认金额是否正确!!");
      }
      // this.postData.payment_code = item.payment_code;
      this.newData = item;
      this.calculatePrice();
      let checkbox = item.mutex.checkbox;
      let radio = item.mutex.radio;
      this.radio_func(radio);
      this.checkbox_func(checkbox);
      // let data = {
      //   ...this.postData,
      //   app_id: this.app_id,
      //   uid: this.user_infor.uid ? this.user_infor.uid : "",
      //   emp_id: localStorage.getItem("choseStaffId")
      //     ? localStorage.getItem("choseStaffId")
      //     : 0,
      //   money: this.inputPrice
      // };
      // this.getAllType(data);
    },
    configuration() {
      var data = {
        token: this.token,
        app_id: this.app_id,
      };
      getConfigButton(data).then((res) => {
        if (res.code == 200) {
          console.log("发票", res.data);
          if (res.data.value) {
            res.data.value.forEach((item) => {
              if (item.name == "cash_int") {
                this.setStatus = item.status == 1;
                console.log("凑整配置 状态", this.setStatus);
              } else if (item.name == "receipt_button") {
                this.isInvoice = item.status == 1;
              } else if (item.name == "default_use_point") {
                this.postData.point = item.status;
              }
            });
          }
        }
      });
    },
    handlePassworld() {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.passwordForm = {
            confirmPassword: "",
            mobile: "",
            code: "",
            pay_pass: "",
            re_pay_pass: "",
          };
          this.setpasswordPopStatus = false;
          this.passwordPopStatus = false;
        })
        .catch((_) => {});
    },
    //重置密码
    resetPassworld(type) {
      // type 1 重置 2 设置
      let data = {
        app_id: this.app_id,
        token: this.token,
        mobile: this.passwordForm.mobile,
        code: this.passwordForm.code,
        pay_pass: this.passwordForm.pay_pass,
        re_pay_pass: this.passwordForm.re_pay_pass,
      };
      setPayPass(data).then((res) => {
        console.log("122", res);
        if (res.code == 200) {
          this.$message.success("成功！！");
          this.passwordForm = {
            confirmPassword: "",
            mobile: "",
            code: "",
            pay_pass: "",
            re_pay_pass: "",
          };
          if (type == 1) {
            this.forgetStatus = false;
          } else {
            // 设置完密码
            this.getImageData()
            this.setpasswordPopStatus = false;
            this.passwordPopStatus = true;
            this.forgetStatus = false;
          }
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 密码弹窗
    passwordldPop() {
      var paymentCodeArrs = [
        "cash",
        "fuiou",
        "wxpay",
        "pos",
        "unionpay",
        "alipay",
        "normal_allinpay",
        "scan_pay",
        "lakala",
        "leshua"
      ];
      let post = this.newPay_type[this.payIndex];
      if (!paymentCodeArrs.includes(post.payment_code)) {
        if (this.open_manage_user_paypass == 1) {
          let data = {
            app_id: this.app_id,
            uid: this.user_infor.uid,
          };
          judgePayPass(data).then((res) => {
            console.log("验证", res);
            this.passwordForm.mobile = this.user_infor.mobile;
            this.getImageData()
            if (res.code == 200) {
             
              this.passwordPopStatus = true;
            } else {
              // 没有密码
            
              this.setpasswordPopStatus = true;
            }
          });
        } else {
          this.$confirm("确认支付吗", "提示", {
            type: "warning",
          })
            .then(() => {
              this.settleAccounts();
            })
            .catch(() => {});
        }
      } else {
        this.settleAccounts();
      }
    },
    changeIc() {
      console.log("ka", this.passwordForm.confirmPassword.length);
      if (this.passwordForm.confirmPassword.length == 6) {
        console.log("ka");
        let data = {
          token: this.token,
          app_id: this.app_id,
          uid: this.user_infor.uid,
          pay_pass: this.passwordForm.confirmPassword,
        };
        verifyPayPass(data).then((res) => {
          if (res.code == 200) {
            this.$message.success("密码正确！！");
            this.settleAccounts();
            this.passwordPopStatus = false;
          } else {
            this.$message.warning(res.msg);
          }
          console.log("数据", res);
        });
      }
    },
    getCode(type = 0) {
      console.log("type", type);
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        if (type == 0) {
          this.SendMyCode();
        } else {
          this.SendUserCode();
        }
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
            this.code_text = this.count + "s";
            this.btn_status = true;
          } else {
            this.btn_status = false;
            this.timer = null;
            this.code_text = "获取验证码";
          }
        }, 1000);
      }
    },
    // 向用户发送验证码
    async SendUserCode() {
      try {
        var data = {
          app_id: this.app_id,
          token: this.token,
          mobile: this.passwordForm.mobile,
          uuid:this.uuid,
          code:this.imgCode
        };
        const res = await iCSendSms(data);
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 计算金额
    calculatePrice() {
      // 计算加油量
      this.$parent.fuel_charge = Number(
        (this.$parent.inputPrice / this.$parent.oil_infor.goods.price).toFixed(
          2
        )
      );
    },
    //扫用户付款码结账
    async keyup_submit(val) {
      console.log(val);
      this.pay_code = val;
      this.loading = true;
      this.Loading_Text = "支付中...";
      let data = {
        ...this.saomaForm,
        auth_code: this.pay_code,
      };
      console.log("saoma", data);
      const res = await CreateOrder_new(data);
      if (res.code == 200) {
        let result1 = setInterval(() => {
          offline_order_query({
            ordersn: res.data.ordersn,
            app_id: this.app_id,
          }).then((status) => {
            if (status.code == 200) {
              this.pay_code = "";
              clearInterval(result1);
              this.loading = false;
              this.dialogVisibleScancode = false;
              this.$message.success("支付成功");
            } else if (status.code == 202) {
            } else {
              this.$message.error("支付失败");
              clearInterval(result1);
              this.timer = null;
              this.loading = false;
            }
          });
        }, 2000);
      } else if (res.code == 202) {
        let result2 = setInterval(() => {
          offline_order_query({
            ordersn: res.data.ordersn,
            app_id: this.app_id,
          }).then((status) => {
            if (status.code == 200) {
              this.pay_code = "";
              clearInterval(result2);
              this.loading = false;
              this.dialogVisibleScancode = false;
              this.$message.success("支付成功");
            } else if (status.code == 202) {
            } else {
              this.$refs.inputbox_pay.focus();
              this.$message.error("支付失败");
              clearInterval(result2);
              this.timer = null;
              this.loading = false;
            }
          });
        }, 2000);
      } else {
        this.loading = false;
        this.pay_code = "";
        this.$refs.inputbox_pay.focus();
        this.$message.error(res.msg);
      }
    },
    // 结账
    async settleAccounts() {
      console.log("fuji", this.$parent);
      let data = {
        app_id: this.app_id,
        emp_id: localStorage.getItem("choseStaffId")
          ? localStorage.getItem("choseStaffId")
          : "", //员工ID,
        money: this.newData.money,
        ...this.postData,
        uid: this.user_infor.uid,
      };
      console.log(data);
      if (this.couponradio) {
        data.coupon_ids = this.couponradio;
      }
      data.payment_code = this.newPay_type[this.payIndex].payment_code;
      if (this.Invoice_id) {
        data.receipt_id = this.Invoice_id;
      }
      if (
        data.payment_code == "balance" ||
        data.payment_code == "card_balance" ||
        data.payment_code == "family_balance" ||
        data.payment_code == "team_balance"
      ) {
        data.pay_password = this.passwordForm.confirmPassword;
        data.account_id = this.newData.account_id;
      }
      if (this.newData.account_name == "微信支付") {
        data.trade_type = "wx";
      }
      if (this.newData.account_name == "支付宝支付") {
        data.trade_type = "ali";
      }

      if (
        data.payment_code == "cash" ||
        data.payment_code == "card_balance" ||
        data.payment_code == "balance" ||
        data.payment_code == "family_balance" ||
        data.payment_code == "team_balance"
      ) {
        this.$parent.LoadingText = "结算中...";
        this.$parent.IsLoading = true;
        const res = await CreateOrder_new(data);
        if (res.code == 200) {
          this.passwordForm.confirmPassword = "";
          this.$parent.inputPrice = "";
          this.payIndex = 0;
          this.$refs.pay_Success.paySuccess = true;
          this.$refs.pay_Success.user = this.user_infor;
          this.$refs.pay_Success.name = this.oil_infor.goods.name;
          this.$refs.pay_Success.fuel_charge = this.$parent.fuel_charge;
          this.$refs.pay_Success.orderData = this.newData;
          this.$refs.pay_Success.order = res.data;
          setTimeout(() => {
            this.$parent.IsLoading = false;
          }, 300);
        } else {
          this.$message(res.msg);
          setTimeout(() => {
            this.$parent.IsLoading = false;
          }, 300);
        }
      } else {
        if (
          data.payment_code == "fuiou" ||
          data.payment_code == "wxpay" ||
          data.payment_code == "alipay" ||
          data.payment_code == "unionpay" ||
          data.payment_code == "normal_allinpay" ||
          data.payment_code == "lakala" ||
          data.payment_code == "leshua"
        ) {
          if (data.trade_type == "wx" || data.trade_type == "ali") {
            let onlinePay_data = {
              app_id: data.app_id,
              emp_id: data.emp_id,
              money: data.money,
              source: "pc",
              cate_id: data.cate_id,
            };
            const res = await createPayQrcode(onlinePay_data);
            if (res.code == 200) {
              this.dialogVisible = true;
              this.$nextTick(() => {
                new QRCode("qrcode", {
                  width: 360,
                  height: 360, // 高度
                  text: res.data.url, // 二维码内容
                });
              });
              let result = setInterval(() => {
                checkPayQrcodeStatus({
                  sn: res.data.sn,
                  app_id: this.app_id,
                }).then((status) => {
                  if (status.code == 200) {
                    if (status.data.status == 1) {
                      this.$parent.LoadingText = "支付中...";
                      this.$parent.IsLoading = true;
                    }
                    if (status.data.status == 2) {
                      clearInterval(result);
                      this.$parent.IsLoading = false;
                      this.dialogVisible = false;
                      this.$alert(
                        `${
                          this.newPay_type[this.payIndex].account_name
                        }成功, 请用户查看${
                          this.newPay_type[this.payIndex].account_name
                        }消息通知`,
                        "成功",
                        {
                          confirmButtonText: "确定",
                          callback: (action) => {
                            this.timer = null;
                            location.reload();
                          },
                        }
                      );
                    }
                    //0未扫码,1未支付,2成功
                  } else {
                    this.$message.error("支付失败");
                    clearInterval(result);
                    this.timer = null;
                    this.$parent.IsLoading = false;
                  }
                });
              }, 4000);
            }
          }
        }
        if (data.payment_code == "pos") {
          const res = await CreateOrder_new(data);
          if (res.code == 200) {
            this.dialogVisiblePos = true;
            let result = setInterval(() => {
              searchOrder({ ordersn: res.data.paysn }).then((status) => {
                if (status.code == 200) {
                  clearInterval(result);
                  this.dialogVisiblePos = false;
                  this.$alert(
                    `${
                      this.newPay_type[this.payIndex].account_name
                    }成功, 请用户查看${
                      this.newPay_type[this.payIndex].account_name
                    }消息通知`,
                    "成功",
                    {
                      confirmButtonText: "确定",
                      callback: (action) => {
                        this.timer = null;
                        location.reload();
                      },
                    }
                  );
                }
              });
            }, 4000);
          }
        }
        if (data.payment_code == "scan_pay") {
          this.saomaForm = data;
          this.dialogVisibleScancode = true;
          this.$nextTick(() => {
            this.$refs.inputbox_pay.focus();
          });
        }
      }
    },
    // 展示支付方式
    goPayMoney() {
      if (this.user_infor && this.inputPrice > 0) {
        this.postData.cate_id = this.oil_infor.id;
        if (localStorage.getItem("choseStaffId")) {
          let data = {
            ...this.postData,
            app_id: this.app_id,
            uid: this.user_infor.uid ? this.user_infor.uid : "",
            emp_id: localStorage.getItem("choseStaffId")
              ? localStorage.getItem("choseStaffId")
              : 0,
            money: this.inputPrice,
          };
          this.getAllType(data);
        }
      } else {
        this.getAllType();
      }
      console.log(this.danxuan, this.duoxuan);
    },
    // 获取支付方式
    async getAllType(obj) {
      try {
        this.newPay_type = [];
        if (obj) {
          this.loading = true;
          this.Loading_Text = "获取中...";
          this.$parent.ISdisabled = true;
          const res = await oderYH(obj);
          if (res.code == 200) {
            let Datas = res.data;
            if (Datas.length > 0) {
              Datas.forEach((item, i) => {
                switch (item.account_name) {
                  case "微信支付":
                    item.imgStatus = true;
                    item.imgUrl = require("../../../../../../public/img/pay/weixin.png");
                    break;
                  case "支付宝支付":
                    item.imgStatus = true;
                    item.imgUrl = require("../../../../../../public/img/pay/zhifu.png");
                    break;
                  case "现金支付":
                    item.imgStatus = true;
                    item.imgUrl = require("../../../../../../public/img/pay/xianjin.png");
                    break;
                  case "刷卡":
                    item.imgStatus = true;
                    item.imgUrl = require("../../../../../../public/img/pay/yinhangka.png");
                    break;
                  case "扫码支付":
                    item.imgStatus = true;
                    item.imgUrl = require("../../../../../../public/img/fukuan.png");
                    break;
                }
              });
              let new_obj = {};
              this.newPay_type = Datas.reduce((cur, next) => {
                new_obj[next.account_name]
                  ? ""
                  : (new_obj[next.account_name] = cur.push(next));
                return cur;
              }, []);
              this.showDiscounts = true;
              console.log("bug", this.payIndex);
              this.newData = Datas[this.payIndex];
              this.calculatePrice();
              let checkbox = Datas[this.payIndex].mutex.checkbox;
              let radio = Datas[this.payIndex].mutex.radio;
              console.log("+++++-----", Datas[this.payIndex]);
              this.radio_func(radio);
              this.checkbox_func(checkbox);
            }
          } else {
            this.$message.error(res.msg);
            this.newPay_type = JSON.parse(JSON.stringify(this.basePay));
            this.loading = false;
            this.$parent.ISdisabled = false;
          }
          // this.$nextTick(()=>{
          this.loading = false;
          this.$parent.ISdisabled = false;
          // })
        } else {
          this.newPay_type = JSON.parse(JSON.stringify(this.basePay));
        }
      } catch (error) {
        console.log(error);
      }
    },
    //同享优惠
    checkbox_func(checkbox) {
      if (!Array.isArray(checkbox)) {
        this.duoxuan = true;
        let coupon = checkbox.coupon;
        let point = checkbox.point;
        let discount = checkbox.discount;
        let platform = checkbox.platform;
        if (coupon) {
          this.Yhq = true;
          if (coupon.checked) {
            this.postData.coupon = 1;
            if (!this.mutexData.includes("2")) {
              if (!this.optionMutex.includes("2")) {
                this.optionMutex.push("2");
              }
            }
            this.couponradio = String(
              coupon.coupon_ids.length == 1
                ? coupon.coupon_ids[0]
                : coupon.coupon_ids.join(",")
            );
            console.log("huixian", this.couponradio);
            if (coupon.list[1].length > 0) {
              coupon.list[1].forEach((item) => {
                if (item.checked) {
                  item.IsShow = String(
                    coupon.coupon_ids.length == 1
                      ? coupon.coupon_ids[0]
                      : coupon.coupon_ids.join(",")
                  );
                }
                if (Array.isArray(item.coupon_data_ids)) {
                  item.coupon_data_ids = String(
                    item.coupon_data_ids.length == 1
                      ? item.coupon_data_ids[0]
                      : item.coupon_data_ids.join(",")
                  );
                }
              });
            }
            if (coupon.list[2].length > 0) {
              coupon.list[2].forEach((item) => {
                if (item.checked) {
                  item.IsShow = String(
                    coupon.coupon_ids.length == 1
                      ? coupon.coupon_ids[0]
                      : coupon.coupon_ids.join(",")
                  );
                }
                if (Array.isArray(item.coupon_data_ids)) {
                  item.coupon_data_ids = String(
                    item.coupon_data_ids.length == 1
                      ? item.coupon_data_ids[0]
                      : item.coupon_data_ids.join(",")
                  );
                }
              });
            }
            if (coupon.list[3].length > 0) {
              coupon.list[3].forEach((item) => {
                if (item.checked) {
                  item.IsShow = String(
                    coupon.coupon_ids.length == 1
                      ? coupon.coupon_ids[0]
                      : coupon.coupon_ids.join(",")
                  );
                }
                if (Array.isArray(item.coupon_data_ids)) {
                  item.coupon_data_ids = String(
                    item.coupon_data_ids.length == 1
                      ? item.coupon_data_ids[0]
                      : item.coupon_data_ids.join(",")
                  );
                }
              });
            }
            this.activeName = String(coupon.coupon_type);
            this.bottom_ticket = `-${coupon.coupon_dec_money}元`;
            this.conponList = coupon.list;
            this.useNum = coupon.coupon_ids.length;
          } else {
            this.postData.coupon = 0;
            if (this.optionMutex.includes("2")) {
              this.optionMutex.splice(this.optionMutex.indexOf("2"), 1);
            }
            this.bottom_ticket = `选择优惠券`;
            this.useNum = 0;
          }
        } else {
          this.Yhq = false;
        }
        if (point) {
          this.jf = true;
          if (point.checked) {
            this.postData.point = 1;
            if (!this.mutexData.includes("1")) {
              if (!this.optionMutex.includes("1")) {
                this.optionMutex.push("1");
              }
            }
            this.integralNum_s = Number(this.user_infor.point);
            this.dedIntegral = point.allow_point;
            this.dedIntegralMoney = point.point_dec_money;
          } else {
            this.postData.point = 0;
            if (this.optionMutex.includes("1")) {
              this.optionMutex.splice(this.optionMutex.indexOf("1"), 1);
            }
            this.dedIntegral = 0;
            this.dedIntegralMoney = 0;
          }
        } else {
          this.jf = false;
        }
        if (discount) {
          this.HY = true;
          this.discount = discount;

          this.discount_dec = discount.discount_str;
          if (this.discount.checked) {
            this.postData.discount = 1;
            if (!this.mutexData.includes("3")) {
              if (!this.optionMutex.includes("3")) {
                this.optionMutex.push("3");
              }
            }
          } else {
            this.postData.discount = 0;
            if (this.optionMutex.includes("3")) {
              this.optionMutex.splice(this.optionMutex.indexOf("3"), 1);
            }
          }
        } else {
          this.HY = false;
        }
        if (platform) {
          this.PTK = true;
          this.platform = platform;
          this.platform_dec = platform.discount_str;
          if (this.platform.checked) {
            this.postData.platform = 1;
            if (!this.mutexData.includes("4")) {
              if (!this.optionMutex.includes("4")) {
                this.optionMutex.push("4");
              }
            }
          } else {
            this.postData.platform = 0;
            if (this.optionMutex.includes("4")) {
              this.optionMutex.splice(this.optionMutex.indexOf("4"), 1);
            }
          }
        } else {
          this.PTK = false;
        }
      } else {
        this.duoxuan = false;
      }
      console.log("-------------", this.mutexData);
    },
    //不同享
    radio_func(radio) {
      this.mutexData = [];
      if (!Array.isArray(radio)) {
        this.danxuan = true;
        let coupon = radio.coupon;
        let point = radio.point;
        this.discount = radio.discount ? radio.discount : null;
        this.platform = radio.platform ? radio.platform : null;
        if (coupon) {
          this.Iscoupon = true;
          if (!this.mutexData.includes("2")) {
            this.mutexData.push("2");
          }
          if (coupon.checked) {
            this.postData.coupon = 1;
            if (!this.optionMutex.includes("2")) {
              this.optionMutex.push("2");
            }
            this.couponradio = String(
              coupon.coupon_ids.length == 1
                ? coupon.coupon_ids[0]
                : coupon.coupon_ids.join(",")
            );
            if (coupon.list[1].length > 0) {
              coupon.list[1].forEach((item) => {
                if (item.checked) {
                  item.IsShow = String(
                    coupon.coupon_ids.length == 1
                      ? coupon.coupon_ids[0]
                      : coupon.coupon_ids.join(",")
                  );
                }
                item.coupon_data_ids = String(
                  item.coupon_data_ids.length == 1
                    ? item.coupon_data_ids[0]
                    : item.coupon_data_ids.join(",")
                );
              });
            }
            if (coupon.list[2].length > 0) {
              coupon.list[2].forEach((item) => {
                if (item.checked) {
                  item.IsShow = String(
                    coupon.coupon_ids.length == 1
                      ? coupon.coupon_ids[0]
                      : coupon.coupon_ids.join(",")
                  );
                }
                item.coupon_data_ids = item.coupon_data_ids = String(
                  item.coupon_data_ids.length == 1
                    ? item.coupon_data_ids[0]
                    : item.coupon_data_ids.join(",")
                );
              });
            }
            if (coupon.list[3].length > 0) {
              coupon.list[3].forEach((item) => {
                if (item.checked) {
                  item.IsShow = String(
                    coupon.coupon_ids.length == 1
                      ? coupon.coupon_ids[0]
                      : coupon.coupon_ids.join(",")
                  );
                }
                item.coupon_data_ids = String(
                  item.coupon_data_ids.length == 1
                    ? item.coupon_data_ids[0]
                    : item.coupon_data_ids.join(",")
                );
              });
            }
            this.activeName = String(coupon.coupon_type);
            this.bottom_ticket = `-${coupon.coupon_dec_money}元`;
            this.conponList = coupon.list;
            this.useNum = coupon.coupon_ids.length;
          } else {
            this.postData.coupon = 0;
            if (this.optionMutex.includes("2")) {
              this.optionMutex.splice(this.optionMutex.indexOf("2"), 1);
            }
            this.bottom_ticket = `选择优惠券`;
            this.useNum = 0;
          }
        } else {
          this.Iscoupon = false;
        }

        if (this.discount) {
          this.Isdiscount = true;
          this.discount_dec = this.discount.discount_str;
          if (!this.mutexData.includes("3")) {
            this.mutexData.push("3");
          }
          if (this.discount.checked) {
            this.postData.discount = 1;
            if (!this.optionMutex.includes("3")) {
              this.optionMutex.push("3");
            }
          } else {
            this.postData.discount = 0;
            if (this.optionMutex.includes("3")) {
              this.optionMutex.splice(this.optionMutex.indexOf("3"), 1);
            }
          }
        } else {
          this.Isdiscount = false;
        }
        if (point) {
          this.Ispoint = true;

          if (!this.mutexData.includes("1")) {
            this.mutexData.push("1");
          }
          if (point.checked) {
            this.postData.point = 1;
            if (!this.optionMutex.includes("1")) {
              this.optionMutex.push("1");
            }
            this.integralNum_s = Number(this.user_infor.point);
            this.dedIntegral = point.allow_point;
            this.dedIntegralMoney = point.point_dec_money;
          } else {
            this.postData.point = 0;
            if (this.optionMutex.includes("1")) {
              this.optionMutex.splice(this.optionMutex.indexOf("1"), 1);
            }
            this.dedIntegral = 0;
            this.dedIntegralMoney = 0;
          }
        } else {
          this.Ispoint = false;
        }
        if (this.platform) {
          this.Isplatform = true;
          this.platform_dec = this.platform.discount_str;
          if (!this.mutexData.includes("4")) {
            this.mutexData.push("4");
          }
          if (this.platform.checked) {
            this.postData.platform = 1;
            if (!this.optionMutex.includes("4")) {
              this.optionMutex.push("4");
            }
          } else {
            this.postData.platform = 0;
            if (this.optionMutex.includes("4")) {
              this.optionMutex.splice(this.optionMutex.indexOf("4"), 1);
            }
          }
        } else {
          this.Isplatform = false;
        }
      } else {
        this.danxuan = false;
      }
    },
    // 显示优惠券列表
    openConponList() {
      if (!this.optionMutex.includes("2")) {
        return this.$message.warning("您还没有勾选是否进行优惠券使用！！");
      }
      this.drawer = true;
    },

    select_Cou(item) {
      this.useNum = item.check_num;
      let arr;
      if (String(item.coupon_data_ids).search(",") != -1) {
        if (item.coupon_data_ids.split(",").length != item.check_num) {
          arr = item.coupon_data_ids.split(",");
          arr.length = item.check_num;
        } else {
          arr = item.coupon_data_ids.split(",");
        }
      } else {
        arr = [item.coupon_data_ids];
      }
      this.set_radio(arr);
    },
    // 选择优惠券
    set_radio(item) {
      // 点击显示单选按钮
      this.postData.coupon_ids = item.length == 1 ? item[0] : item.join(",");
      let data = {
        ...this.postData,
        app_id: this.app_id,
        uid: this.user_infor.uid ? this.user_infor.uid : "",
        emp_id: localStorage.getItem("choseStaffId")
          ? localStorage.getItem("choseStaffId")
          : 0,
        money: this.inputPrice,
      };
      this.getAllType(data);
      this.drawer = false;
    },
    // 结账后刷新用户信息
    payEnd() {
      this.$emit("payEnd");
      this.newData = {};
      this.postData.point = 1;
      this.postData.coupon = 1;
      this.postData.discount = 1;
      this.postData.platform = 0;
      this.postData.platform_card_data_id = 0;
      // setTimeout(() => {
      //   location.reload();
      // }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("./discount.scss");
.money-pay {
  flex: 1;
  padding: 0 10px;
  padding-right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
  .box-card {
    margin-bottom: 10px;
    .el-card__body {
      padding: 10px 15px;
    }
    .pay-money {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-input {
        flex: 1;
        text-align: right;
        .el-input__inner {
          border: 0;
          text-align: right;
          color: #f56c6c;
          font-size: 30px;
        }
      }
    }
    .oilinfor {
      display: flex;
      justify-content: space-between;
      height: 30px;
      line-height: 30px;
      font-size: 18px;

      .oilinfor-name {
        color: #999;

        .oil {
          color: #e6a23c;
        }
      }
    }
    .weight {
      font-size: 18px;
      height: 30px;
      line-height: 30px;
      color: #999;
    }
  }
  .activityList {
    .activity-cont {
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      line-height: 20px;
      height: 20px;
      .hint {
        font-size: 14px;
        color: #999;
        margin-right: 5px;
      }
    }
    .activity-cont:last-child {
      margin-bottom: 0px;
    }
  }
  .No_preferential {
    width: 100%;
    height: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #fff;
    color: #bfbfbf;
    font-size: 18px;
    border-radius: 5px;
    img {
      width: 20%;
    }
  }
  .pay_infor {
    margin-bottom: 10px;
    .pay_price {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .price {
        color: #f56c6c;
        span {
          font-size: 24px;
        }
      }
    }
  }
  .submitAccounts {
    .el-button {
      width: 100%;
      height: 70px;
      background: linear-gradient(90deg, #fd7f51, #fc3b39);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      img {
        width: 24px;
        margin-right: 10px;
      }
    }
  }
  .selectPay_type {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    cursor: pointer;

    .shell {
      width: 25%;
      padding: 6px;
      height: 100px;
      .pay_type {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        background: #f3f3f3;
        border-radius: 5px;
        padding: 10px 0;
        border: 1px solid #d8d8d8;
        img {
          width: 40px;
        }
      }
    }
    .pay_type_Active {
      .pay_type {
        border: 1px solid #409eff;
        background: #fff;
      }
    }

    span {
      text-align: center;
    }
  }
}

.coupon_list {
  padding: 0 30px;
  height: 100%;
  overflow: auto;

  .el-radio-group {
    width: 100%;
  }
}
.noUseconpon {
  width: 100%;
  position: absolute;
  // height: 40px;
  bottom: 0;
  padding: 0 10px 10px;
  z-index: 9;

  .el-button {
    width: 100%;
  }
}
</style>

<style lang="scss">
.coupon-money {
  .el-input-number--mini {
    line-height: 20px;
  }
  .el-input--mini .el-input__inner {
    height: 20px;
    line-height: 20px;
    border: 1px solid #378ae8;
    background-color: #ffffff3b;
    color: #fff;
  }
  .el-input-number__decrease,
  .el-input-number__increase {
    background: transparent;
    border: 0;
    color: #fff;
  }
}
.select_coupon {
  .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
  }
  .el-tabs__item {
    padding: 0 40px !important;
    font-size: 16px;
  }
}
.select_coupon-drawer {
  .el-drawer__header {
    margin-bottom: 16px;
  }
}
</style>
